// src/components/sections/Footer.jsx
// FOOTER ULTRA RESPONSIVE - EXPERIENCIA PERFECTA EN TODAS LAS PANTALLAS

import { Logo } from "../ui/Logo"; // Importamos el nuevo componente Logo
// Cambiar la línea de importación:
import { sections } from "../../content"; // ✅ CORREGIDO

export const Footer = ({ id = "main-footer" }) => {
  // Obtener los datos del footer desde content.js
  const footerData = sections.footer.data;

  const {
    showLogo = true,
    quickLinks = [],
    socialMedia = [],
    legalLinks = [],
    languageSelector = { show: true, current: "ESPAÑOL" },
    copyright = "©2024 Zero Latency MTY. Todos los derechos reservados.",
    backgroundColor = "#000000",
    textColor = "white",
  } = footerData;

  // Iconos SVG de redes sociales - Responsive
  const getSocialIcon = (platform) => {
    const baseClasses =
      "w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 transition-all duration-200";

    const icons = {
      facebook: (
        <svg
          className={baseClasses}
          viewBox="0 0 12 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.87385 3.62583C9.94173 3.62583 11.7481 3.64174 11.7481 3.64174V0.0138466C11.7481 0.0138466 10.4913 -0.0173083 8.84203 0.0138466C7.19281 0.0450015 3.14068 0.170947 3.14068 4.9456V8.02397H0V11.7931H3.14134V23.5723H7.63295V11.7931H11.3079L11.7474 8.02397H7.63229V4.9456C7.63229 4.9456 7.8053 3.62649 8.87318 3.62649L8.87385 3.62583Z"
            fill="white"
          />
        </svg>
      ),
      twitter: (
        <svg
          className={baseClasses}
          viewBox="0 0 23 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.800414 0.696289L9.12474 11.8265L0.748047 20.8761H2.63325L9.96725 12.9528L15.8926 20.8761H22.3086L13.5156 9.12005L21.3129 0.696289H19.4277L12.6737 7.99317L7.21634 0.696289H0.800414ZM3.5732 2.085H6.52032L19.5358 19.4873H16.5887L3.5732 2.085Z"
            fill="white"
          />
        </svg>
      ),
      linkedin: (
        <svg
          className={baseClasses}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.94947 0.00537109C1.49115 0.00537109 0.308594 1.18793 0.308594 2.64625C0.308594 4.10456 1.49115 5.28712 2.94947 5.28712C4.40778 5.28712 5.59035 4.10456 5.59035 2.64625C5.59035 1.18793 4.40778 0.00537109 2.94947 0.00537109Z"
            fill="white"
          />
          <path
            d="M5.33375 7.05566H0.565063V21.5666H5.33375V7.05566Z"
            fill="white"
          />
          <path
            d="M16.6656 6.71436C14.8308 6.71436 13.5421 7.58934 12.6406 8.70761V7.0564H7.87195V21.5673H12.6406V13.064C12.7699 11.2371 14.0738 10.7605 14.9991 10.7605C15.9736 10.7605 17.2038 11.2351 17.2038 13.9012V21.5673H21.9725V11.3465C21.9725 11.3465 21.7591 6.71436 16.6656 6.71436Z"
            fill="white"
          />
        </svg>
      ),
      instagram: (
        <svg
          className={baseClasses}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.998927 7.41669C1.02809 5.95241 1.25413 4.51663 2.08603 3.25519C2.85629 2.08721 3.91025 1.29972 5.24329 0.851619C6.54848 0.412136 7.89212 0.411473 9.23708 0.408822C11.8216 0.404181 14.4068 0.408822 16.9913 0.434011C18.4444 0.447931 19.8337 0.75484 21.062 1.57216C22.4461 2.49421 23.2899 3.8067 23.5723 5.43272C23.7387 6.39322 23.8189 7.37957 23.8235 8.35399C23.8361 11.1354 23.8057 13.9161 23.7619 16.6975C23.742 17.9205 23.4696 19.0965 22.8253 20.1557C22.0517 21.4265 20.9507 22.2696 19.5262 22.729C18.2316 23.1466 16.9045 23.1605 15.5741 23.1632C13.038 23.1685 10.5005 23.1618 7.96371 23.1453C6.63266 23.1367 5.3394 22.9113 4.1648 22.2504C2.79332 21.4788 1.87922 20.3301 1.40858 18.8187C1.09107 17.7999 1.03074 16.7539 0.983018 15.7026C0.974401 15.517 0.957829 9.54914 0.99959 7.41735L0.998927 7.41669ZM3.2149 17.3458C3.33024 18.4389 3.79094 19.4133 4.71299 20.1239C5.61317 20.8186 6.66581 21.0294 7.73899 21.0553C11.1541 21.1361 14.5712 21.2621 17.983 20.9479C18.7513 20.8769 19.4513 20.6091 20.0697 20.1484C21.2509 19.2695 21.6579 17.9954 21.6918 16.618C21.7547 14.0587 21.7428 11.4973 21.7335 8.93731C21.7302 8.02123 21.6858 7.1005 21.5883 6.19038C21.4816 5.19408 21.074 4.31843 20.311 3.63302C19.4658 2.87404 18.4384 2.58237 17.346 2.5605C14.5666 2.50482 11.7858 2.46571 9.00574 2.48361C7.98691 2.4909 6.95416 2.49885 5.95322 2.81902C4.25826 3.36058 3.33621 4.64788 3.21225 6.24208C3.05648 8.2413 3.07835 16.0585 3.2149 17.3465V17.3458Z"
            fill="white"
          />
          <path
            d="M12.4275 5.93647C15.6039 5.91195 18.3065 8.52498 18.2939 11.8261C18.2813 15.1093 15.539 17.6845 12.3744 17.6587C9.13963 17.6328 6.47755 14.99 6.51467 11.7379C6.55179 8.48256 9.18537 5.89736 12.4275 5.93647ZM16.1992 11.838C16.2635 9.8315 14.5341 8.01988 12.4155 8.01855C10.3321 8.01722 8.61795 9.72743 8.61862 11.7518C8.61862 13.8969 10.299 15.5799 12.4434 15.5766C14.4897 15.5733 16.1979 13.873 16.1992 11.838Z"
            fill="white"
          />
          <path
            d="M18.5019 7.06214C17.7396 7.1324 17.1325 6.44567 17.1119 5.72049C17.0914 4.97675 17.7628 4.31984 18.5139 4.33045C19.2848 4.34172 19.9371 4.98271 19.9072 5.73308C19.8801 6.42512 19.3179 7.13041 18.5019 7.06214Z"
            fill="white"
          />
        </svg>
      ),
      youtube: (
        <svg
          className={baseClasses}
          viewBox="0 0 28 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.7495 0.536133H5.72901C3.02118 0.536133 0.826416 2.7309 0.826416 5.43872V14.1343C0.826416 16.8421 3.02118 19.0368 5.72901 19.0368H22.7495C25.4574 19.0368 27.6521 16.8421 27.6521 14.1343V5.43872C27.6521 2.7309 25.4574 0.536133 22.7495 0.536133ZM11.6922 13.0856V6.30178L18.3792 9.69369L11.6922 13.0856Z"
            fill="white"
          />
        </svg>
      ),
      tiktok: (
        <svg
          className={baseClasses}
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
            fill="white"
          />
        </svg>
      ),
    };
    return icons[platform] || null;
  };

  // Icono de globo para selector de idioma - Responsive
  const GlobeIcon = () => (
    <svg
      className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1944_7537)">
        <path
          d="M10.6748 0C5.15258 0 0.674805 4.47778 0.674805 10C0.674805 15.5222 5.15258 20 10.6748 20C16.197 20 20.6748 15.5222 20.6748 10C20.6748 4.47778 16.197 0 10.6748 0ZM1.80536 10.5556H5.53036C5.56647 11.8417 5.72203 13.0556 5.9748 14.1583H2.82203C2.24425 13.0722 1.88592 11.85 1.80536 10.5556ZM11.2304 4.73056V1.22222C12.2442 1.56389 13.2415 2.81944 13.9054 4.73056H11.2304ZM14.2359 5.84167C14.4998 6.90278 14.672 8.11389 14.7081 9.44444H11.2304V5.84167H14.2359ZM10.1192 1.22222V4.73056H7.44425C8.11092 2.81944 9.10536 1.56389 10.1192 1.22222ZM10.1192 5.84167V9.44444H6.64147C6.67758 8.11389 6.8498 6.90278 7.11369 5.84167H10.1192ZM5.53036 9.44444H1.80536C1.88592 8.15 2.24425 6.92778 2.82203 5.84167H5.97758C5.72203 6.94445 5.56647 8.15833 5.53314 9.44444H5.53036ZM6.64147 10.5556H10.1192V14.1583H7.11369C6.8498 13.0972 6.67758 11.8861 6.64147 10.5556ZM10.1192 15.2694V18.7778C9.10536 18.4361 8.10814 17.1806 7.44425 15.2694H10.1192ZM11.2304 18.7778V15.2694H13.9054C13.2387 17.1806 12.2442 18.4361 11.2304 18.7778ZM11.2304 14.1583V10.5556H14.7081C14.672 11.8861 14.4998 13.0972 14.2359 14.1583H11.2304ZM15.8193 10.5556H19.5443C19.4637 11.85 19.1054 13.0722 18.5276 14.1583H15.372C15.6276 13.0556 15.7831 11.8417 15.8165 10.5556H15.8193ZM15.8193 9.44444C15.7831 8.15833 15.6276 6.94445 15.3748 5.84167H18.5304C19.1081 6.92778 19.4665 8.15 19.547 9.44444H15.822H15.8193ZM17.8276 4.73056H15.072C14.6665 3.44722 14.1165 2.36389 13.4609 1.56111C15.2248 2.14444 16.7442 3.26667 17.8276 4.73056ZM7.88869 1.56111C7.23314 2.36389 6.68314 3.44722 6.27758 4.73056H3.52203C4.60258 3.26667 6.1248 2.14444 7.88869 1.56111ZM3.52203 15.2694H6.27758C6.68314 16.5528 7.23314 17.6361 7.88869 18.4389C6.1248 17.8556 4.60536 16.7333 3.52203 15.2694ZM13.4637 18.4389C14.1193 17.6361 14.6692 16.5528 15.0748 15.2694H17.8304C16.7498 16.7333 15.2276 17.8556 13.4637 18.4389Z"
          fill="white"
        />
      </g>
    </svg>
  );

  return (
    <footer
      id={id}
      className="w-full"
      style={{ backgroundColor, color: textColor }}
    >
      <div
        className="
        w-full max-w-8xl mx-auto
        px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16
        py-8 sm:py-12 md:py-16 lg:py-20
      "
      >
        {/* Main Footer Content - Ultra Responsive Grid */}
        <div
          className="
          grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 
          gap-6 sm:gap-8 md:gap-10 lg:gap-12 
          mb-6 sm:mb-8 md:mb-10 lg:mb-12
        "
        >
          {/* Logo Section - Responsive */}
          <div
            className="
            footer-logo-section 
            col-span-1 lg:col-span-1
            flex flex-col items-start justify-start
          "
          >
            {showLogo && (
              <a href="/es/" className="inline-block mb-4 sm:mb-6">
                <Logo
                  className="w-[120px] sm:w-[140px] md:w-[160px] lg:w-[180px] xl:w-[200px]"
                  style={{
                    transform: "scale(1.5)",
                    transformOrigin: "left center",
                  }}
                />
              </a>
            )}
          </div>

          {/* Quick Links Section - Responsive */}
          <div className="footer-links col-span-1">
            <h5
              className="
              text-secondary font-sweet font-black tracking-wider mb-4 sm:mb-6
              text-base sm:text-lg md:text-xl
            "
            >
              ENLACES RÁPIDOS
            </h5>
            <div className="space-y-2 sm:space-y-3">
              {quickLinks.map((link, index) => (
                <div key={index}>
                  <a
                    href={link.href}
                    target={link.external ? "_blank" : undefined}
                    rel={link.external ? "noopener noreferrer" : undefined}
                    className="
                      group flex items-center text-white hover:text-secondary 
                      transition-colors duration-200 font-sweet
                      text-sm sm:text-base md:text-lg
                      touch-manipulation
                    "
                  >
                    <span className="font-bold tracking-wide">
                      {link.label}
                    </span>
                    {link.external && (
                      <svg
                        className="
                          ml-2 text-gray-400 group-hover:text-secondary
                          w-3 h-3 sm:w-4 sm:h-4
                        "
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1M14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1" />
                      </svg>
                    )}
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Social Media Section - Responsive */}
          <div className="footer-social col-span-1 md:col-span-2 lg:col-span-1">
            <h5
              className="
              text-secondary font-sweet font-black tracking-wider mb-4 sm:mb-6
              text-base sm:text-lg md:text-xl
            "
            >
              SÍGUENOS
            </h5>
            <div className="flex flex-wrap gap-3 sm:gap-4 md:gap-5">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="nofollow"
                  className="
                    flex items-center justify-center 
                    hover:scale-110 transition-transform duration-200
                    w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12
                    rounded-full
                    touch-manipulation
                  "
                  aria-label={social.platform}
                >
                  {getSocialIcon(social.platform)}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Footer Bottom - Ultra Responsive */}
        <div
          className="
          border-t border-gray-800 pt-4 sm:pt-6 md:pt-8
        "
        >
          <div
            className="
            flex flex-col lg:flex-row items-start lg:items-center 
            justify-between gap-2 sm:gap-6
          "
          >
            {/* Language Selector & Legal Links */}
            <div
              className="
              flex flex-col sm:flex-row items-start sm:items-center 
              gap-3 sm:gap-4 md:gap-6 w-full lg:w-auto
            "
            >
              {/* Globe + Language Selector */}
              <div className="flex items-center gap-2 sm:gap-3">
                <GlobeIcon />

                {languageSelector.show && (
                  <div className="relative">
                    <select
                      className="
                        bg-white cursor-pointer border border-gray-600 rounded 
                        text-primary  
                        transition-all duration-300 ease-in-out 
                        focus:outline-none
                        px-2 py-2 sm:px-3 sm:py-1.5
                        text-xs sm:text-sm font-medium
                        touch-manipulation
                      "
                      defaultValue="es"
                    >
                      <option value="es">ESPAÑOL</option>
                      <option value="en">ENGLISH</option>
                      <option value="de">DEUTSCH</option>
                    </select>
                  </div>
                )}
              </div>

              {/* Legal Links - Responsive */}
              <div
                className="
                flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4
                text-xs sm:text-sm
              "
              >
                {legalLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className="
                      text-white font-bold hover:text-secondary 
                      transition-colors duration-200 font-sweet tracking-wide
                      touch-manipulation
                    "
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Copyright - Responsive */}
            <div
              className="
              text-white font-sweet font-medium
              text-xs sm:text-xs
              mt-2 lg:mt-0
            "
            >
              {copyright}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
